import { gql } from '@apollo/client'

export const SEARCH_AVAILABILITY_QUERY = gql`
  query SearchAvailability($input: SearchAvailabilityInput!) {
    searchAvailability(input: $input) {
      entities {
        entityBasicDetails {
          propertyName
          propertyCode
          displayPropertyCode
          images
          coverImage
          starClass
          propertyType
          facilities {
            ID
            Name
          }
          bestAvailableRate
          cityName
          maxPrice
          description
          checkPolicy {
            checkInFrom
            checkInTo
            checkOutFrom
            checkOutTo
          }
          address
          website
          latitude
          longitude
        }
        rooms {
          roomTypeCode
          displayRoomTypeCode
          roomTypeName
          images
          occupancy {
            adults
            defaultOccupancy
            extraBeds
            children
            total
            maxOccupancy
          }
          facilities {
            ID
            Name
          }
          ratePlans {
            ratePlanName
            ratePlanCode
            displayRatePlanCode
            cancellationPolicy {
              priorityOrder
              description
              percentage
              deadline
              deadlineType
              offset
              baseFee
              applied
            }
            modificationPolicy {
              priorityOrder
              description
              percentage
              deadline
              deadlineType
              offset
              baseFee
              applied
            }
            valueAddInclusions
            taxInclusive
            boardType
            price {
              currency
              beforeDiscount {
                roomPrice
                childrenPrice
                extraBedPrice
                totalPrice
                flatRateAddOns {
                  name
                  code
                  amount
                  totalAmount
                  currency
                  perPerson
                  perNight
                }
              }
              afterDiscount {
                roomPrice
                childrenPrice
                extraBedPrice
                totalPrice
                flatRateAddOns {
                  name
                  code
                  amount
                  totalAmount
                  currency
                  perPerson
                  perNight
                }
              }
              rateBreakouts {
                rateBreakoutType
                amount
                currency
              }
            }
            pricePerDay {
              date
              price {
                currency
                beforeDiscount {
                  roomPrice
                  childrenPrice
                  extraBedPrice
                  totalPrice
                  childrenRate {
                    minAge
                    maxAge
                    rate
                  }
                  extraBedRate
                  perNightAddOns {
                    name
                    code
                    amount
                    totalAmount
                    currency
                    perPerson
                    perNight
                  }
                }
                afterDiscount {
                  roomPrice
                  childrenPrice
                  extraBedPrice
                  totalPrice
                  childrenRate {
                    minAge
                    maxAge
                    rate
                  }
                  extraBedRate
                  perNightAddOns {
                    name
                    code
                    amount
                    totalAmount
                    currency
                    perPerson
                    perNight
                  }
                }
              }
            }
            isBulkRateConditions
            bulkRateConditions {
              minGuestNumber
              maxGuestNumber
              minRoomStayNumber
              maxRoomStayNumber
            }
            pooledAvailability
            allocatedAvailability
            providerCode
            displayProviderCode
            providerId
            providerName
            restrictions {
              closeToArrival
              closeToDeparture
              maxStay
              minStay
              status
            }
            availablePaymentMethods
            ratePolicy
            hash
            bookabilityStatus
            walletEligibilities {
              walletID
              bookabilityStatus
            }
          }
        }
      }
      lengthOfStay
      guestCount
      currency
    }
  }
`
